import React, { useState } from 'react';
import HomeLayout from '../../../containers/HomeLayout';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Switch from '@material-ui/core/Switch';

import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../store/actions/profileActions';
import { Link, useHistory } from 'react-router-dom';

import '../../../assets/css/settings.css';
import SettingsLayout from '../../../containers/SettingsLayout';

const Settings = () => {
    const [open, setOpen] = useState(false);
    const [activeOpen, setActiveOpen] = useState(false);
    const userProfile = useSelector(state => state.profile.userProfile);
    const dispatch = useDispatch();
    const history = useHistory();

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        setActiveOpen(false);
    }

    const onChange = () => {
        setActiveOpen(true);
    }

    const handleConfirm = type => {
        switch(type){
            case 'delete':
                dispatch(actions.deleteProfiles(userProfile.userId))
                    .then(() => {
                        setOpen(false);
                        history.push('/');
                    });
            case 'mute':
                dispatch(actions.updateProfile({...userProfile, isActive: !userProfile.isActive}))
                    .then(() => {
                        setActiveOpen(false);
                    });
            default:
                break;
        }
        
    }

    return (
        <SettingsLayout>
            <div className="pref-button-row">
                <a href="#">
                    <i className="fa fa-home"></i>
                </a>
            </div>    
            <div className="content-row">

                <div className="content-title">
                    <h1>Settings</h1>
                </div>

                <div className="content-blocks">
                    <div className="settings-block">
                        <div className="settings-form">
                            <fieldset>
                                <div style={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                    <p style={{ marginBottom: '0px', color: '#41004C', fontWeight: 'bold' }}>Show me on Univrs</p>
                                    <Switch
                                        style={{color: '#41004C'}}
                                        checked={userProfile.isActive}
                                        onChange={onChange}
                                        name="checkedA"
                                        inputProps={{ 'aria-label': 'secondary checkbox' }} />
                                </div>

                            </fieldset>

                            <label className="form-label">Display Name</label>
                            <input  
                                type="text"
                                className="settings-input"
                                placeholder={userProfile.profileName}
                                disabled />

                            
                            {/* <label className="form-label">Email Address</label>
                            <input  
                                type="text"
                                className="settings-input"
                                placeholder="example: 202987678@student.uj.ac.za"
                                disabled /> */}

                            <div className="settings-button-set">
                                <Link to="/account/reset/password" style={{textDecoration: 'none'}} className="settings-button">Change Password</Link>
                                <button className="settings-button" onClick={handleOpen}>Delete Account</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Delete Account</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete your account?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={() => handleConfirm('delete')} color="primary">
                    Confirm
                </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={activeOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Mute Account</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to mute your account?
                        This will not include your profile when making recommendations
                        to other users
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={() => handleConfirm('mute')} color="primary">
                    Confirm
                </Button>
                </DialogActions>
            </Dialog>
        </SettingsLayout>
    );
}

export default Settings;